import React, { useState } from 'react';
import UserOrderDetails from './user-order-details-table';
import OwnerOutletList from './owner-outlet-list-table';
import AuctionDetails from './auction-details-table';
import AccountSection from './account-section';
import DeHubOrderListTable from '../../dailyEssentials/deOrders/OrdersList';
import OwnerHubList from './owner-hub-list-table';

const UserDetailsTab = (props) => {
    const [isActive, setIsActive] = useState(0);
    const [value, setValue] = useState(0);

    const handleChange = (newValue) => {
        setIsActive(newValue);
        setValue(newValue);
    };

    return (
        <div>
            <div className="d-inline-block">
                {props.isOwner === false ?
                    <div>
                        <button className={isActive === 0 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(0)}>Food Orders</button>
                        <button className={isActive === 1 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(1)}>Daily Essential Orders</button>
                        <button className={isActive === 2 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(2)}>Auction Details</button>
                    </div>
                    :
                    <div>
                        <button className={isActive === 0 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(0)}>Outlet List</button>
                        <button className={isActive === 5 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(5)}>Hub List</button>
                        <button className={isActive === 1 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(1)}>Food Orders</button>
                        <button className={isActive === 2 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(2)}>Daily Essential Orders</button>
                        <button className={isActive === 3 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(3)}>Auction Details</button>
                        <button className={isActive === 4 ? 'panel-btn is-active' : 'panel-btn'} onClick={() => handleChange(4)}>Account</button>
                    </div>}
            </div>
            {/* <div className="d-inline-block float-md-right mt-3">
                <span className="mr-5">See Newer</span>
                <span>See Older</span>
            </div> */}
            <div>
                {props.isOwner === false ?
                    <>
                        {value === 0 ? <UserOrderDetails userId={props.userId} />
                            : value === 1 ? <DeHubOrderListTable userId={props.userId} />
                                : value === 2 ? <AuctionDetails userId={props.userId} />
                                    : null}
                    </>
                    :
                    <>
                        {value === 0 ? (
                            <OwnerOutletList data={props.data} />
                        ) : value === 5 ? (
                            <OwnerHubList data={props.hubData} />
                        ) :value === 1 ? (
                            <UserOrderDetails userId={props.userId} />
                        ) : value === 2 ? (
                            <DeHubOrderListTable userId={props.userId} />
                        ) : value === 3 ? (
                            <AuctionDetails userId={props.userId} />
                        ) : (
                            <AccountSection userAc={props.uDetails} rerenderParentCallback={props.rerenderParentCallback} />
                        )}
                    </>
                }

            </div>
        </div>
    );
}
export default UserDetailsTab;